var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "checkbox-field",
    {
      attrs: {
        value: _vm.value,
        condensed: true,
        "display-name": "Digital delivery agreement",
        name: _vm.name,
        "data-qa": "digital-delivery-agreement",
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    },
    [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.Resources.Checkout.CheckboxDigitalDeliveryAgreementMessage
          ) +
          "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }